import { client as request } from "./request";
import Permission from "@/models/permission";
import Service from "@/models/service";

export interface ServiceRole {
  id: any;
  name: string;
}

export interface ServiceUser {
  userId: number;
  staffId: number;
  role: ServiceRole;
}

export interface ServiceArise {
  id: any;
  arise: string;
  service: string;
}

export async function getServiceUsers() {
  const users: ServiceUser[] = await request.get("get_service_users.php");
  return users;
}

/**
 * サービスの権限一覧を取得する
 */
export async function getServiceRoles() {
  const res = await request.get("get_service_roles.php");
  return res as ServiceRole[];
}

/**
 * 権限を付与する
 */
export async function assignServiceRole(staffId: any, serviceRoleId: any) {
  const d = new FormData();
  d.append("staffId", staffId);
  d.append("serviceRoleId", serviceRoleId);
  await request.post("assign_service_role.php", d);
}

/**
 * 権限を剥奪する
 */
export async function removeServiceRole(staffId: any) {
  const d = new FormData();
  d.append("staffId", staffId);
  await request.post("remove_service_role.php", d);
}

/**
 * 自分がサービスで持つ権限を得る
 */
export async function getServicePermissions(): Promise<Permission[]> {
  const permissions = await request.get("get_service_permissions.php");
  return permissions || [];
}

/**
 * サービスを切り替える
 */
export async function switchService(id: number): Promise<string> {
  const data = await request.get("switch_service.php", {
    serviceId: id
  });
  return data.accessToken;
}

/**
 * 利用できるサービスを得る
 */
export async function getUserServices(): Promise<Service[]> {
  const services = await request.get("get_user_services.php");
  return services.map((s: any) => new Service(s));
}

export async function getUserAriseServices(): Promise<ServiceArise[]> {
  const services = await request.get("get_user_services.php");
  return services.map((s: any) => new Service(s));
}

// export async function getUserServiceServices(): Promise<ServiceService[]> {
//   const services = await request.get("get_user_services.php");
//   return services.map((s: any) => new Service(s));
// }

export interface ServiceSettingTask {
  id?: string | number;
  editable: string | number;
}
export async function getServiceSettingTask(): Promise<ServiceSettingTask> {
  return await request.get("get_service_setting_task.php");
}

export async function saveServiceSettingTask(data: ServiceSettingTask) {
  await request.post("save_service_setting_task.php", data);
}

export async function addStorageLimitService(increaseStorageValue: any) {
  const d = new FormData();
  d.append("increase_value", increaseStorageValue);
  await request.post("increase_storage_limit_service.php", d);
}

export async function saveScheduleNotifion(scheduleNotification: boolean) {
  return await request.post("save_schedule_notification.php", {
    scheduleNotification
  });
}
